import React, { useEffect, useRef } from 'react';
import { hapticFeedback } from '../utils/telegramSdk';

export function BottomMenu({ activeItem, onItemClick, className, showProfile = true }) {
    const menuRef = useRef(null);

    const menuItems = [
        { id: 'vpn', label: 'VPN', icon: 'vpn' },
        { id: 'wallet', label: 'Кошелёк', icon: 'wallet' },
        { id: 'ref', label: 'Рефералы', icon: 'ref' },
        { id: 'profile', label: 'Профиль', icon: 'profile' },
        { id: 'faq', label: 'FAQ', icon: 'faq' }
    ];

    // Обновление высоты меню
    useEffect(() => {
        const updateMenuHeight = () => {
            if (menuRef.current) {
                const menuHeight = menuRef.current.offsetHeight;
                const totalHeight = menuHeight + 55; // margin + offset
                document.documentElement.style.setProperty('--menu-height', `${totalHeight}px`);
            }
        };

        updateMenuHeight();
        window.addEventListener('resize', updateMenuHeight);

        const observer = new ResizeObserver(updateMenuHeight);
        if (menuRef.current) observer.observe(menuRef.current);

        return () => {
            window.removeEventListener('resize', updateMenuHeight);
            observer.disconnect();
        };
    }, []);

    const handleClick = (itemId) => {
        if (itemId === activeItem) return;

        onItemClick(itemId);

        if (hapticFeedback?.impactOccurred?.isAvailable()) {
            hapticFeedback.impactOccurred('light');
        }
    };
    const visibleItems = showProfile
        ? menuItems
        : menuItems.filter(item => item.id !== 'profile');
    const platform = window.Telegram?.WebApp?.platform;
    const isWindows = platform === 'windows' || platform === 'tdesktop' || platform === 'web';
    return (
        <div ref={menuRef} className={`v1_61 ${className || ''}`} style={(isWindows ? {margin: '0'} : {margin: '0 0 28px'})}>
            {visibleItems.map(item => {
                const isActive = activeItem === item.id;

                return (
                    <div
                        key={item.id}
                        className={`menu-item ${isActive ? 'active' : ''}`}
                        onClick={() => handleClick(item.id)}
                    >
                        <div className={`menu-icon icon-${item.icon}`}></div>
                        <span className="menu-text">{item.label}</span>
                    </div>
                );
            })}
        </div>
    );
}
